import { FINLAND_REGION_SLUGS } from './region-slug';
import type { LocationLocale } from './generate-localized-location-url';
import { JOBS_LISTING_SEGMENT } from '../constants/url-constants';

/** Maakunta (Finnish admin1 region) path marker per locale: fi `maakunta`, sv `landskap`, en `region`. */
export const REGION_PATH_MARKER_BY_LOCALE: Record<'en' | 'fi' | 'sv', string> = {
  en: 'region',
  fi: 'maakunta',
  sv: 'landskap',
};

/**
 * Builds a locale-relative `/jobs/region/{slug}`-style path (fi `/tyopaikat/maakunta/{slug}`, sv
 * `/lediga-jobb/landskap/{slug}`) for a maakunta hub SRP link, mirroring `buildLocationSrpPath`'s
 * shape (no BASE_URL prefix; the `<Link>` component prepends the app's own origin).
 *
 * Pass `roleSlug` to build the combined `/jobs/region/{slug}/role/{roleSlug}` region x role page.
 * Returns `undefined` for a placeId that isn't one of the 18 Finnish maakunta.
 */
export function buildRegionHubPath(
  placeId: string,
  locale: LocationLocale,
  roleSlug?: string,
): string | undefined {
  const slugs = FINLAND_REGION_SLUGS[placeId];
  if (!slugs) return undefined;
  const regionSegment = REGION_PATH_MARKER_BY_LOCALE[locale];
  const roleSegment = locale === 'fi' ? 'ammatti' : locale === 'sv' ? 'yrke' : 'role';
  const jobsSegment = JOBS_LISTING_SEGMENT[locale];
  let path = `/${jobsSegment}/${regionSegment}/${slugs[locale]}`;
  if (roleSlug) path += `/${roleSegment}/${roleSlug}`;
  return path;
}
